export default __webpack_public_path__ + "static/media/11.9d69e290.jpg";